import { Injectable } from '@angular/core';
import * as _ from 'lodash'
@Injectable({
  providedIn: 'root'
})
export class EncoderService {
  defaultKeyCode: string = '_ltmsLabel';
  constructor() { }
  getEncodedConfiguration(defaultConfiguration, labelsDictionary, keyToUpdate, cb) {
    if (!keyToUpdate) {
      keyToUpdate = this.defaultKeyCode;
    }
    var tmpConfiguration = JSON.parse(JSON.stringify(defaultConfiguration));
    var tmpLabelsDictionary = JSON.parse(JSON.stringify(labelsDictionary));
    this.processObject(tmpConfiguration, (path, path1, key, obj) => {
      if (key && key.indexOf(keyToUpdate) >= 0) {
        obj[key] = this.getIdForText(tmpLabelsDictionary, obj[key]);
      }
    });

    cb({
      "configuration": tmpConfiguration,
      "labelsDictionary": tmpLabelsDictionary
    });
  }

  processObject(obj, callback, currentPath?: any, currentPath1?: any) {
    if (!currentPath) {
      currentPath = [];
    }
    if (!currentPath1) {
      currentPath1 = "";
    }
    if (obj) {
      Object.keys(obj).forEach((key) => {
        this.compute(obj, key, callback, currentPath, currentPath1)
      });
    }
    return;
  }

  compute(obj, key, callback, currentPath?: any, currentPath1?: any) {
    var value = obj[key];
    if (typeof value !== 'object') {
      callback(currentPath, currentPath1, key, obj);
    } else {
      var path = currentPath.slice(0);
      path.push(key);

      var path1 = currentPath1;
      path1 = path1.concat(key);

      this.processObject(value, callback, path, path1);
    }
  }

  overrideObjectValues(src, targetField, targetValue, cb) {
    try {
      if (!_.isEmpty(src)) {
        var tmpSrc = Helpers.deepClone(src);
        this.processObject(tmpSrc, (path, path1, key, obj) => {
          if (key && key.indexOf(targetField) >= 0) {
            obj[key] = targetValue;
          }
        });
        cb(tmpSrc);
      }
    } catch (e) {
      console.log("Encoder.overrideObjectValues() - Error occured while overriding the object", e);
      cb({ "Error": true });
    }
  }

  getIdForText(labelsDictionary, label) {
    if (label) {
      var properyFound: any = null;
      for (var propName in labelsDictionary) {
        var propValue = labelsDictionary[propName];
        if (propValue == label) {
          properyFound = propName;
          break;
        }
      }
      if (properyFound) {
        return properyFound;
      } else {
        properyFound = ("label_" + ((new Date()).getTime().toString()) + Helpers.getRandomString()).toLowerCase();
      }
      this.updateLabelsDictionary(labelsDictionary, properyFound, label);
      return properyFound;
    }
  }

  updateLabelsDictionary(labelsDictionary, labelId, label) {
    if (labelId && label)
      labelsDictionary[labelId.toString()] = label;
  }

  /**
   * [replaceKeys loops through the object and replaces the object key with the specified key]
   * @param  {object} object             [source object]
   * @param  {string} oldKey             [key to be replaced]
   * @param  {string} newKey             [new key which needs to be replaced with the oldKey]
   * @param  {array} excludedProperties [properties where keys needs to be exclude]
   * @return {object}                    [object with the new keys]
   */

  replaceKeys(object, oldKey, newKey, excludedProperties) {
    var build, key, destKey, ix, value;
    build = {};
    try {
      for (key in object) {
        if (excludedProperties.indexOf(key.toString()) == -1) {
          // Get the destination key
          ix = [oldKey].indexOf(key);
          destKey = ix === -1 ? key : [newKey][ix];

          // Get the value
          value = object[key];

          // If this is an object, recurse
          if (typeof value === "object" && !(value instanceof Array)) {
            value = this.replaceKeysInternal(value, oldKey, newKey, excludedProperties);
          }

          // Set it on the result using the destination key
          build[destKey] = value;
        } else {
          build[key.toString()] = object[key.toString()]
        }
      }
    } catch (e) {
      build = object
    }
    return build;
  }

  replaceKeysInternal(object, oldKey, newKey, excludedProperties) {
    var tmpObject = JSON.parse(JSON.stringify(object));
    return this.replaceKeys(tmpObject, oldKey, newKey, excludedProperties);
  }
}
